import React, { useState, useEffect, useCallback, use } from 'react';
// NOTE: Migrated from @shopify/polaris React components to Polaris Web Components
// Removed: TextField, FormLayout, InlineGrid, IndexTable, Pagination, EmptySearchResult, Collapsible, Tabs, Spinner, Layout, Modal, Frame, ProgressBar, Icon, Button, Banner, Box
// Migrated to: s-text-field, s-spinner, s-modal, s-progress-bar, s-icon, s-button, s-banner, s-box, CSS visibility for Collapsible
// import { useBreakpoints } from '@shopify/polaris';
import axios from 'axios';
import Presets from '../../common/Presets';
import { getMappedTemplates, getShopUrl } from '../../Services/CommonServices';
import { environment } from '../../Services/environment';
import { timezoneOptions } from '../../common/TimezoneOptions';
import CSVMapping from '../CSVMapping';
import { ToastMarkup } from '../../common/ToastMarkup';
import { outlineSvg } from '../../common/svgs';
const endpoint = environment.serverUrl;
const XMLConnection = ({ mappingHtml, schedulerConfig, schedulerConfigHistory, action, setXmlConfigAction, jobId, setJobId, templateId, integrationConfig, setIntegrationConfig, setCompletedSteps, completed, fetchMappingData, xmlFields, shopifyFields, refreshConfigList, onModalClose, selectedIntegration }) => {
  //////////// integrations satate ///////
  var storeUrl = getShopUrl();
  const [xmlActive, setXmlActive] = useState(false);
  const handleXmlChange = useCallback(() => { setXmlActive(!xmlActive); setXmlConfigAction('Create'); setSelectedTemplateID("0"); }, [xmlActive]);
  const [existingTemplates, setExistingTemplates] = useState([]);
  // const [xmlHeaders, setXmlHeaders] = useState([]);
  const [shopifyHeaders, setShopifyHeaders] = useState([]);
  const [presetModalActive, setPresetModalActive] = useState(false);
  const [selectedTemplateID, setSelectedTemplateID] = useState("0");
  const [selectedTemplate, setSelectedTemplate] = useState();
  const [expanded, setExpanded] = useState(1);
  const [XMLUrl, setXMLUrl] = useState('');
  const [urlError, setUrlError] = useState('');
  const [FormLoading, setFormLoading] = useState(false);
  const [toast, setToast] = useState(false);
  const toggleToast = useCallback(() => setToast((toast) => !toast), []);
  const [saveLoading, setSaveLoading] = useState(false);
  ///////////// integration state end ////////////

  // Initialize timezone if not set
  useEffect(() => {
    if (!integrationConfig.timeZone && setIntegrationConfig) {
      const defaultTimeZone = timezoneOptions[0]?.value || 'UTC';
      setIntegrationConfig((prev) => ({ ...prev, timeZone: defaultTimeZone }));
    }
  }, []);

  // Control modal show/hide
  useEffect(() => {
    const modal = document.getElementById('xml-connection-modal');
    if (!modal) return;

    if (xmlActive) {

      modal.showOverlay();
    } else {

      modal.hideOverlay();
    }
  }, [xmlActive]);

  // Handle modal hide event
  useEffect(() => {
    const modal = document.getElementById('xml-connection-modal');
    if (!modal) return;

    const handleHide = () => {

      setXmlActive(false);
      setXmlConfigAction('');
      setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
      setJobId(null);
      if (onModalClose) {
        onModalClose();
      }
    };

    modal.addEventListener('hide', handleHide);
    return () => modal.removeEventListener('hide', handleHide);
  }, [onModalClose]);

  useEffect(() => {

    if (completed.step1 && completed.step2) {
      setExpanded(0);
    }

    else if (completed.step1) {
      setExpanded(2);
      if (action === "create" || action === "createExpand") {
        fetchMappingData();
      }
      else if (action === "edit" || action === "editExpand") {
        fetchMappingData();
        handleEdit(selectedTemplateID);
      }
    }
    else {
      setExpanded(1);
    }
  }, [completed]);

  useEffect(() => {

  }, [xmlFields]);

  useEffect(() => {

    if (shopifyFields && shopifyFields.length > 0) {
      const optionsWithDefault = ["Select a value", ...shopifyFields];
      setShopifyHeaders(optionsWithDefault);

    }
  }, [shopifyFields]);


  useEffect(() => {


    // Only process if this is an XML integration action
    if (selectedIntegration !== 'XML') {
      return;
    }

    if ((action === 'edit' || action === 'editExpand') && jobId) {

      setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
      setExpanded(1);
      setFormLoading(true);
      getTemplates();
      getConfigById();
      setXmlActive(true);
    }
    if (action === 'create' || action === 'createExpand') {

      setXmlActive(true);
    }
    if (action === 'delete' && jobId) {
      deleteConfigById(jobId);
    }
  }, [action, jobId, selectedIntegration]);


  const deleteConfigById = async (deleteId) => {
    const response = await fetch(
      `${endpoint}/api/Integrations/config-delete?storeUrl=${storeUrl}&jobId=${deleteId}`,
      {
        method: 'DELETE',
      }
    );

    if (!response.ok) {
      throw new Error('Failed to delete XML config');
    }
    const result = await response.json();
    setXmlConfigAction("refresh");
  };

  const updateIntegrationField = (field, value) => {
    setIntegrationConfig((prev) => ({ ...prev, [field]: value }));
  };

  function getTemplates() {
    getMappedTemplates(storeUrl, "XML").then(function (result) {
      if (result !== null) {
        setExistingTemplates(result);
        const existingTemp = [{
          id: "0",
          name: "Select a Template",
          template: "{}"
        }];
        existingTemp.push(...result);
      }
      else {
        // setTempLoading(false);
      }
    });
  }

  const getConfigById = async () => {
    const response = await fetch(`${endpoint}/api/Integrations/config-jobid?jobId=${jobId}&storeUrl=${storeUrl}`);
    if (!response.ok) {
      throw new Error('Failed to fetch XML config');
    }
    const data = await response.json();

    updateIntegrationField('xmlUrl', data.feedUrl || '');
    updateIntegrationField('cronExpression', data.cronExpression || '');
    updateIntegrationField('jobName', data.jobName || '');
    updateIntegrationField('timeZone', data.timeZone || timezoneOptions[0]?.value || 'UTC');
    setSelectedTemplateID(data.templateId);
    setFormLoading(false);
  }

  const handleEdit = (id) => {
    //  setExpanded(1);


    const template = existingTemplates?.find(
      (t) => t.id === parseInt(id)
    );

    if (template !== null && template !== undefined) {
      fetchMappingData();

      // const templateJson = template?.template;

      // const parsedTemplate = JSON.parse(templateJson);
      // console.log("parsedTemplate:", parsedTemplate);
      // const csvHeaderSet = new Set();
      // const shopifyHeaderSet = new Set();
      // parsedTemplate?.productMapping?.forEach(item => {
      //   if (item?.csvHeader) csvHeaderSet.add(item.csvHeader.trim());
      //   item?.shopifyHeaders?.forEach(sh => {
      //     if (sh?.header) shopifyHeaderSet.add(sh.header.trim());
      //   });
      // });
      // parsedTemplate?.tagsMapping?.forEach(tag => {
      //   if (tag?.mappedHeader) csvHeaderSet.add(tag.mappedHeader.trim());
      // });
      // parsedTemplate?.metafieldMapping?.forEach(meta => {
      //   if (meta?.csvHeaders) csvHeaderSet.add(meta.csvHeaders.trim());
      // });
      // const csvHeaders = Array.from(csvHeaderSet);
      // const shopifyHeaders = Array.from(shopifyHeaderSet);
      // // setXmlHeaders(csvHeaders);
      // const optionsWithDefault = [
      //   "Select a value",
      //   ...shopifyFields
      // ];
      // setShopifyHeaders(optionsWithDefault);
      setPresetModalActive(true);
      setSelectedTemplate(id);
    }
    else {
      setSelectedTemplateID("0");
    }
  };
  const ACCORDION_ITEMS = [
    {
      id: 1,
      completed: (action === "edit" || action === "editExpand") ? true : completed.step1 || false,
      title: (action === "edit" || action === "editExpand") ? "Edit Existing Feed" : "Create New Feed",
      content: (
        <>
          {FormLoading ? (
            <s-stack direction="inline" align='center'>
              <s-spinner size="small"></s-spinner>
            </s-stack>
          ) : (
            <>
              {schedulerConfig}

            </>
          )}
        </>
      )
    },
    {
      id: 2,
      title: "Template Mapping",
      completed: (action === "edit" || action === "editExpand") ? true : completed.step2 || false,
      content: (
        <>
          {(action === "edit" || action === "editExpand") ? (
            <>
              <s-text as='p' tone='subdued'>
                This section allows you to map values from your data feed to corresponding Shopify fields.
              </s-text>
              {(selectedTemplateID !== "0" && selectedTemplateID !== undefined && selectedTemplateID !== null && selectedTemplateID !== 0 && xmlFields?.length > 0 && shopifyHeaders?.length > 0) ? (
                <CSVMapping cancelUpload={() => setPresetModalActive(false)} uploadError={() => setPresetModalActive(false)} submitUpload={() => setPresetModalActive(false)} csvHeaders={xmlFields} incomingShopifyHeaders={shopifyHeaders} activate={presetModalActive} file={null} storeUrl={storeUrl} dbTagSeparator={""} currentRoute={"preset"} uploadType={"XML"} ftpConfig={null} templateEditId={selectedTemplate} setCompletedSteps={setCompletedSteps}></CSVMapping>
              ) : (
                mappingHtml
              )}
            </>
          ) : (action === "create" || action === "createExpand" && completed.step1) ? (
            <>
              <s-text as='p' tone='subdued'>
                This section allows you to map values from your data feed to corresponding Shopify fields else.
              </s-text>
              {mappingHtml}
            </>
          ) : (
            <s-banner tone="info">
              <div slot="title">Test Sheets connection to enable template mapping.</div>
              <s-text>
                Please ensure that the  connection is successfully tested in the "Create New Feed" section before proceeding to template mapping.
              </s-text>
            </s-banner>
          )}
        </>
      )
    }
  ];

  const completedItemsLength = ACCORDION_ITEMS.filter((item) => item.completed).length;
  const accordianMarkup = (
    <s-stack gap="none">
      {ACCORDION_ITEMS.map(({ title, id, content, completed }) => {
        const isExpanded = expanded === id;
        return (
          <s-box
            key={id}
            background="bg-surface"
            border="none"
            padding="none"
          >
            <s-clickable
              border="base"
              padding="base"
              background="subdued"
              borderRadius="base"
              onClick={() => {
                setExpanded((prev) => (id === prev ? null : id));

                if (id === 2 && (action === "edit" || action === "editExpand")) {
                  handleEdit(selectedTemplateID);
                }
                if (id === 2 && (action === "create" || action === "createExpand")) {
                  setSelectedTemplateID("0");
                  fetchMappingData();
                }
                if (action === "create" || action === "createExpand") {
                  setXmlConfigAction("createExpand");
                } else {
                  setXmlConfigAction("editExpand");
                }
              }}
            >
              <s-stack direction="inline" align="space-between" blockAlign="center">
                <s-stack direction="inline" gap="base" blockAlign="center">
                  {completed ? (
                    <s-icon type="status-active" />
                  ) : (
                    <s-icon type="status" />
                  )}
                  <s-text type="strong">{title}</s-text>
                </s-stack>
                <s-icon type={isExpanded ? "chevron-up" : "chevron-down"} />
              </s-stack>
            </s-clickable>

            {isExpanded && (
              <s-box padding="base" background="bg-surface">
                {content}
              </s-box>
            )}
          </s-box>
        );
      })}
    </s-stack>
  );

  const saveIntegrationConfig = async () => {
    try {
      setSaveLoading(true);
      let configToSave = { ...integrationConfig };
      configToSave.ImportFormat = "XML";
      configToSave.ftpConfig = null;
      // Ensure timezone is set, with fallback to first timezone option
      configToSave.timeZone = integrationConfig.timeZone || timezoneOptions[0]?.value || 'UTC';
      configToSave.templateId = templateId !== "0" ? templateId : selectedTemplateID;
      if (!configToSave) {
        setSaveLoading(false);
        return;
      }
      else {
        var res = await fetch(`${endpoint}/api/Integrations/add-config?storeUrl=${storeUrl}&importType=${"XML"}`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ feedUrl: configToSave.xmlUrl, cronExpression: configToSave.cronExpression, jobName: configToSave.jobName, jobId, timeZone: configToSave.timeZone, templateId: configToSave.templateId }),
        });
        if (!res.ok) {
          setSaveLoading(false);
          throw new Error('Failed to save integration config');

        }
        else {
          setSaveLoading(false);
          setToast(true);
          setXmlActive(false);
          setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
          setXmlConfigAction('');
          setJobId(null);
          // Refresh the config list in the parent component
          if (refreshConfigList) {
            refreshConfigList();
          }
        }
      }
      setCompletedSteps((prev) => ({ ...prev, step1: false, step2: false }));
    } catch (error) {
      setSaveLoading(false);

    }
  }

  return (
    <>
      <style>
        {`
          /* Parent XML Connection Modal */
          #xml-connection-modal {
            z-index: 1000 !important;
          }
          #xml-connection-modal::part(overlay) {
            z-index: 999 !important;
          }
          #xml-connection-modal::part(dialog) {
            z-index: 1001 !important;
          }
          
          /* Nested Edit Schedule Modal - Higher z-index to appear on top */
          #cron-edit-modal-xml {
            z-index: 1100 !important;
          }
          #cron-edit-modal-xml::part(overlay) {
            z-index: 1099 !important;
          }
          #cron-edit-modal-xml::part(dialog) {
            z-index: 1101 !important;
          }
        `}
      </style>
      <s-modal
        padding="none"
        id="xml-connection-modal"
        heading={(action === 'edit' || action === "editExpand") ? 'Edit XML Connection' : 'Edit Connection'}
        size='large'
      >
        {accordianMarkup}

        <s-stack slot="secondary-actions" direction="inline" gap='small' blockAlign='center'>
          {completedItemsLength === ACCORDION_ITEMS.length ? (
            <>
              <s-icon type="check" tone='subdued' />
              <s-text tone='subdued'>Done</s-text>
            </>
          ) : (
            <>
              <s-text tone='subdued'>
                {`${completedItemsLength} / ${ACCORDION_ITEMS.length} completed`}
              </s-text>
              <div style={{ width: '120px' }}>
                <s-progress-bar
                  progress={(completedItemsLength / ACCORDION_ITEMS.length) * 100}
                  size='small'
                  tone='primary'
                />
              </div>
            </>
          )}
        </s-stack>

        <s-button
          slot="primary-action"
          variant="primary"
          loading={saveLoading}
          disabled={action === "edit" || action === "editExpand" ? false : (completed.step1 === false || completed.step2 === false)}
          onClick={() => { saveIntegrationConfig(); }}
        >
          Save
        </s-button>
      </s-modal>
      {/* <CSVMapping cancelUpload={() => setPresetModalActive(false)} uploadError={() => setPresetModalActive(false)} submitUpload={() => setPresetModalActive(false)} csvHeaders={xmlHeaders} incomingShopifyHeaders={shopifyFields} activate={presetModalActive} file={null} storeUrl={storeUrl} dbTagSeparator={""} currentRoute={"preset"} uploadType={"XML"} ftpConfig={null} templateEditId={selectedTemplate} setCompletedSteps={setCompletedSteps}></CSVMapping> */}
      <ToastMarkup toast={toast} toggleToast={toggleToast} content={"Saved"} />
    </>
  );
}


export default XMLConnection;

